import { Interpolation, Theme, css } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  width: 100%;
  max-width: 1190px;
  padding: 24px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
`

export const title: Interpolation<Theme> = (theme) => css`
  font-size: 22px;
  font-weight: 700;
  line-height: 27.72px;
  padding-bottom: 24px;

  ${theme.breakpoints.down('lg')} {
    padding-top: 24px;
  }
`

export const content: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  padding-top: 16px;
  gap: 14px;
`

export const filtersWrapper: Interpolation<Theme> = css`
  display: flex;
  gap: 12px;
`

export const filters: Interpolation<Theme> = css`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const dateRangeFilters: Interpolation<Theme> = css`
  display: flex;
  gap: 12px;

  & > div {
    flex: 1;
  }
`

export const statisticsWrapper: Interpolation<Theme> = (theme) => css`
  width: 100%;
  padding: 12px;
  border-radius: 14px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: 0px 5px 7px -1px #8a94a621;

  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const statisticsBlock: Interpolation<Theme> = (theme) => css`
  padding: 12px;
  border-radius: 10px;
  background-color: ${theme.colors.backgroundFive};
  display: flex;
  flex-direction: column;
`

export const statisticsRow: Interpolation<Theme> = (theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;

  :not(:first-of-type) {
    border-top: 1px dashed ${theme.backgrounds.backgroundOne};
  }
`

export const firstRow: Interpolation<Theme> = css`
  padding: 0;
`

export const statisticsBlockTitle: Interpolation<Theme> = css`
  color: #21252b;
  font-size: 16px;
  font-weight: 600;
  line-height: 20.16px;
`

export const statisticLabel: Interpolation<Theme> = css`
  color: #21252b;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
`

export const statisticValue: Interpolation<Theme> = css`
  color: #3c414a;
  font-size: 14px;
  font-weight: 400;
  line-height: 17.64px;
`
